import { SCOPE_3_CATEGORIES_KEYS } from "./const";
import categoryRegistry from "./categoryRegistry";
import {
  CategoryOne,
  CategoryTwo,
  CategoryThree,
  CategoryFour,
  CategoryFive,
  CategorySix,
  CategorySeven,
  CategoryEight,
  CategoryNine,
  CategoryTen,
  CategoryEleven,
  CategoryTwelve,
  CategoryThirteen,
  CategoryFourteen,
  CategoryFifteen,
  CategoryFiveConsumptionBased,
  CategoryFiveConsumptionBasedPreview,
  CategoryFourConsumptionBased,
  CategoryFourConsumptionBasedPreview,
  CategoryNineConsumptionBased,
  CategoryNineConsumptionBasedPreview
} from "./categories";
import {
  ImportItemsButton
} from "../../../../../OrganizationQuestionnaire/components/Categories/components/ImportItemsButton";
import {
  supplierQuestionnaireWasteGeneratedInOperationsKeys, useImportSupplierQuestionnaireWasteGeneratedInOperationsItems
} from "../../../../../../hooks/query/supplier-questionnaire/tabs/categories";
import {
  supplierQuestionnaireUpstreamTransportationAndDistributionKeys,
  useImportSupplierQuestionnaireUpstreamTransportationAndDistributionItems
} from "../../../../../../hooks/query/supplier-questionnaire/tabs/categories/upstream-transportation-and-distribution";
import {
  supplierQuestionnaireDownstreamTransportationAndDistributionKeys,
  useImportSupplierQuestionnaireDownstreamTransportationAndDistributionItems
} from "../../../../../../hooks/query/supplier-questionnaire/tabs/categories/downstream-transportation-and-distribution";

export const COMPONENT_TYPES = Object.freeze({
  EMISSION_BASED: "EMISSION_BASED",
  CONSUMPTION_BASED: "CONSUMPTION_BASED",
  CONSUMPTION_BASED_PREVIEW: "CONSUMPTION_BASED_PREVIEW",
  CUSTOM_HEADER: "CUSTOM_HEADER"
});

export const CUSTOM_HEADER_ATTRS = Object.freeze({
  "COMPONENT": "COMPONENT",
  "PROPS": "PROPS"
});

categoryRegistry.register(SCOPE_3_CATEGORIES_KEYS.categoryOne,
  { [COMPONENT_TYPES.EMISSION_BASED]: CategoryOne });
categoryRegistry.register(SCOPE_3_CATEGORIES_KEYS.categoryTwo,
  { [COMPONENT_TYPES.EMISSION_BASED]: CategoryTwo });
categoryRegistry.register(SCOPE_3_CATEGORIES_KEYS.categoryThree,
  { [COMPONENT_TYPES.EMISSION_BASED]: CategoryThree });
categoryRegistry.register(SCOPE_3_CATEGORIES_KEYS.categoryFour, {
  [COMPONENT_TYPES.EMISSION_BASED]: CategoryFour,
  [COMPONENT_TYPES.CONSUMPTION_BASED]: CategoryFourConsumptionBased,
  [COMPONENT_TYPES.CONSUMPTION_BASED_PREVIEW]: CategoryFourConsumptionBasedPreview,
  [COMPONENT_TYPES.CUSTOM_HEADER]: {
    [CUSTOM_HEADER_ATTRS.COMPONENT]: ImportItemsButton,
    [CUSTOM_HEADER_ATTRS.PROPS]: {
      itemsKeys: supplierQuestionnaireUpstreamTransportationAndDistributionKeys,
      importItemsHook: useImportSupplierQuestionnaireUpstreamTransportationAndDistributionItems,
      itemsType: "consumption-based-upstream-transportation-and-distribution"
    }
  }
});
categoryRegistry.register(SCOPE_3_CATEGORIES_KEYS.categoryFive, {
  [COMPONENT_TYPES.EMISSION_BASED]: CategoryFive,
  [COMPONENT_TYPES.CONSUMPTION_BASED]: CategoryFiveConsumptionBased,
  [COMPONENT_TYPES.CONSUMPTION_BASED_PREVIEW]: CategoryFiveConsumptionBasedPreview,
  [COMPONENT_TYPES.CUSTOM_HEADER]: {
    [CUSTOM_HEADER_ATTRS.COMPONENT]: ImportItemsButton,
    [CUSTOM_HEADER_ATTRS.PROPS]: {
      itemsKeys: supplierQuestionnaireWasteGeneratedInOperationsKeys,
      importItemsHook: useImportSupplierQuestionnaireWasteGeneratedInOperationsItems,
      itemsType: "consumption-based-waste-generated-in-operations"
    }
  }
});
categoryRegistry.register(SCOPE_3_CATEGORIES_KEYS.categorySix,
  { [COMPONENT_TYPES.EMISSION_BASED]: CategorySix });
categoryRegistry.register(SCOPE_3_CATEGORIES_KEYS.categorySeven,
  { [COMPONENT_TYPES.EMISSION_BASED]: CategorySeven });
categoryRegistry.register(SCOPE_3_CATEGORIES_KEYS.categoryEight,
  { [COMPONENT_TYPES.EMISSION_BASED]: CategoryEight });
categoryRegistry.register(SCOPE_3_CATEGORIES_KEYS.categoryNine,{
  [COMPONENT_TYPES.EMISSION_BASED]: CategoryNine,
  [COMPONENT_TYPES.CONSUMPTION_BASED]: CategoryNineConsumptionBased,
  [COMPONENT_TYPES.CONSUMPTION_BASED_PREVIEW]: CategoryNineConsumptionBasedPreview,
  [COMPONENT_TYPES.CUSTOM_HEADER]: {
    [CUSTOM_HEADER_ATTRS.COMPONENT]: ImportItemsButton,
    [CUSTOM_HEADER_ATTRS.PROPS]: {
      itemsKeys: supplierQuestionnaireDownstreamTransportationAndDistributionKeys,
      importItemsHook: useImportSupplierQuestionnaireDownstreamTransportationAndDistributionItems,
      itemsType: "consumption-based-downstream-transportation-and-distribution"
    }
  }
});
categoryRegistry.register(SCOPE_3_CATEGORIES_KEYS.categoryTen,
  { [COMPONENT_TYPES.EMISSION_BASED]: CategoryTen });
categoryRegistry.register(SCOPE_3_CATEGORIES_KEYS.categoryEleven,
  { [COMPONENT_TYPES.EMISSION_BASED]: CategoryEleven });
categoryRegistry.register(SCOPE_3_CATEGORIES_KEYS.categoryTwelve,
  { [COMPONENT_TYPES.EMISSION_BASED]: CategoryTwelve });
categoryRegistry.register(SCOPE_3_CATEGORIES_KEYS.categoryThirteen,
  { [COMPONENT_TYPES.EMISSION_BASED]: CategoryThirteen });
categoryRegistry.register(SCOPE_3_CATEGORIES_KEYS.categoryFourteen,
  { [COMPONENT_TYPES.EMISSION_BASED]: CategoryFourteen });
categoryRegistry.register(SCOPE_3_CATEGORIES_KEYS.categoryFifteen,
  { [COMPONENT_TYPES.EMISSION_BASED]: CategoryFifteen });

export { default as ScopeThree } from "./ScopeThree";